import React from 'react';
import { ApButtonGroup, ApButtonDanger } from '@alixpartners/ui-components';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { ApiDataContext } from 'contexts/ApiDataContext';
import { SettingsContext } from 'contexts/SettingsContext';
import {
	Wrapper,
	StyledButtonSecondary,
	StyledModal,
} from '../ChangeTypeModal/styles';
import { convertToArray, isCustomCategory } from 'Details/utils';
import { moveToBin } from 'utils/apiRequests';
import { VENDOR_TYPES } from 'Details/utils';
import { ModalText, ModalSecondaryText } from '../../Settings/Bin/Bin.styles';

const SPEND_TYPE = {
	INDIRECT: '1',
	DIRECT: '0',
};

export class MoveToBinModal extends React.Component {
	state = {
		isLoading: false,
	};

	moveToBin = () => {
		const {
			currency,
			currencyType,
			supplierId,
			dateFrom,
			dateTo,
			hierarchy,
			showNonSourceable,
			isHarmonized,
			customFiltersValues,
			customFilters,
			clearApiCache,
			categoryHierarchy,
			divisionName,
			categoryName,
			dimensionName,
			dimensions = [],
			onClose,
			includeCustomCategories = false,
			waterfallFilter,
			selectedDimensionKey,
			selectedDimensionName,
			storedQueryId,
			spendType,
			onSubmit,
			extraFilters,
			isPmi,
			isDimensions,
			requestDimensions,
		} = this.props;
		const params = {
			includeCustomCategories,
		};
		const dimensionValue =
			selectedDimensionKey === 'spendType'
				? SPEND_TYPE[selectedDimensionName.toUpperCase()]
				: selectedDimensionName;

		params.dateFrom = dateFrom;
		params.dateTo = dateTo;
		params.filters = ['sourceable'];
		params.filterValues = [showNonSourceable === 'false'];

		if (dimensionName) {
			params.filters = [...params.filters, dimensions[0]];
			params.filterValues = [...params.filterValues, dimensionName];
		}

		if (selectedDimensionKey) {
			const filterName = selectedDimensionKey;

			params.filters = [...params.filters, selectedDimensionKey];
			params.filterValues = [...params.filterValues, dimensionValue];

			if (hierarchy) {
				params.hierarchy = hierarchy;
			}

			if (filterName !== dimensions[0]) {
				params.filters = [
					...params.filters,
					...(waterfallFilter ? [waterfallFilter[0]] : []),
				];
				params.filterValues = [
					...params.filterValues,
					...(waterfallFilter ? [waterfallFilter[1]] : []),
				];
			}
		} else if (supplierId) {
			const filterName = !isHarmonized
				? VENDOR_TYPES.original
				: VENDOR_TYPES.harmonized;

			params.filters = [...params.filters, filterName];
			params.filterValues = [...params.filterValues, supplierId];

			if (hierarchy) {
				params.hierarchy = hierarchy;
			}

			if (filterName !== dimensions[0]) {
				params.filters = [
					...params.filters,
					...(waterfallFilter ? [waterfallFilter[0]] : []),
				];
				params.filterValues = [
					...params.filterValues,
					...(waterfallFilter ? [waterfallFilter[1]] : []),
				];
			}
		} else if (categoryHierarchy) {
			params.hierarchy = categoryHierarchy;
			params.filters = [
				...params.filters,
				...(waterfallFilter ? [waterfallFilter[0]] : []),
			];
			params.filterValues = [
				...params.filterValues,
				...(waterfallFilter ? [waterfallFilter[1]] : []),
			];
		} else if (divisionName) {
			params.filters = [
				...params.filters,
				'purchasingLegalEntity',
				...(waterfallFilter ? [waterfallFilter[0]] : []),
			];
			params.filterValues = [
				...params.filterValues,
				divisionName,
				...(waterfallFilter ? [waterfallFilter[1]] : []),
			];

			if (hierarchy) {
				params.hierarchy = hierarchy;
			}
		} else if (categoryName) {
			const filterName = includeCustomCategories
				? 'clientCategoryL4'
				: 'categoryL4';

			params.filters = [
				...params.filters,
				filterName,
				...(waterfallFilter ? [waterfallFilter[0]] : []),
			];
			params.filterValues = [
				...params.filterValues,
				categoryName,
				...(waterfallFilter ? [waterfallFilter[1]] : []),
			];

			if (hierarchy) {
				params.hierarchy = hierarchy;
			}
		}

		if (customFiltersValues.length > 0) {
			params.filters = [...params.filters, ...customFilters];
			params.filterValues = [...params.filterValues, ...customFiltersValues];
		}

		if (isPmi && spendType) {
			params.filters = [...(params.filters || []), 'spendType'];
			params.filterValues = [
				...(params.filterValues || []),
				SPEND_TYPE[spendType],
			];
		}

		if (extraFilters) {
			const filterObj = Object.keys(extraFilters).reduce(
				(acc, filterName) => {
					return {
						...acc,
						filters: [
							...acc.filters,
							...new Array(extraFilters[filterName].length).fill(filterName),
						],
						filterValues: [...acc.filterValues, ...extraFilters[filterName]],
					};
				},
				{
					filters: [],
					filterValues: [],
				}
			);

			params.filters = [...params.filters, ...filterObj.filters];
			params.filterValues = [...params.filterValues, ...filterObj.filterValues];
		}

		if (storedQueryId) {
			params.storedQueryId = storedQueryId;
		}

		if (!isPmi && spendType) {
			params.filters = [...(params.filters || []), 'spendType'];
			params.filterValues = [
				...(params.filterValues || []),
				SPEND_TYPE[spendType],
			];
		}
		if (isDimensions) {
			params.dimensions = requestDimensions;
		}
		params.currency = currency;
		params.currencyType = currencyType;

		this.setState({
			isLoading: true,
		});

		moveToBin(params)
			.then(() => {
				this.setState({ isLoading: false });
				clearApiCache();

				onClose();

				if (onSubmit) {
					onSubmit();
				}
			})
			.catch(() => {
				this.setState({ isLoading: false });
			});
	};

	render() {
		const { onClose, isOpen } = this.props;
		const { isLoading } = this.state;

		return (
			<MoveToBinViewModal
				isOpen={isOpen}
				onClose={onClose}
				moveToBin={this.moveToBin}
				isLoading={isLoading}
			/>
		);
	}
}

export const MoveToBinViewModal = ({
	isOpen,
	onClose,
	moveToBin,
	isLoading,
}) => (
	<Wrapper onClick={e => e.stopPropagation()}>
		<StyledModal
			isOpen={isOpen}
			header="Move to bin"
			isDismissible
			hasClosed={onClose}
			footer={({ handleClose }) => {
				return (
					<ApButtonGroup justifyContent="flex-end">
						<StyledButtonSecondary onClick={handleClose}>
							Cancel
						</StyledButtonSecondary>
						<ApButtonDanger onClick={moveToBin} disabled={isLoading}>
							Move to bin
						</ApButtonDanger>
					</ApButtonGroup>
				);
			}}
		>
			<ModalText>
				You are about to move these transactions to the bin. Are you sure you
				want to proceed?
			</ModalText>
			<ModalSecondaryText>
				Transactions can be restored by going to settings and then navigating to
				the bin.
			</ModalSecondaryText>
		</StyledModal>
	</Wrapper>
);

export default props => (
	<ApiDataContext.Consumer>
		{({ clearApiCache }) => (
			<SettingsContext.Consumer>
				{({ customFilters: customFilterOptions }) => (
					<QueryStringContext.Consumer>
						{({
							currency,
							currencyType,
							customFilters,
							customFiltersValues,
							waterfallFilter,
							dateFrom,
							dateTo,
							measures,
							showNonSourceable,
							showHarmonizedVendors,
							dimensions,
							showNegativeSpend,
							storedQueryId,
							storedQuery,
						}) => (
							<MoveToBinModal
								currency={currency}
								currencyType={currencyType}
								dateFrom={dateFrom}
								dimensions={dimensions}
								dateTo={dateTo}
								customFilters={convertToArray(customFilters)}
								customFiltersValues={convertToArray(customFiltersValues)}
								waterfallFilter={waterfallFilter}
								customFilterOptions={customFilterOptions}
								hierarchy={measures}
								showNonSourceable={showNonSourceable}
								clearApiCache={clearApiCache}
								includeCustomCategories={isCustomCategory(dimensions)}
								isHarmonized={showHarmonizedVendors === 'true'}
								showNegativeSpend={
									props.showNetSpend && showNegativeSpend === 'true'
								}
								storedQueryId={storedQueryId}
								storedQuery={storedQuery}
								// Added to set hierarchy and other props manually
								{...props}
							/>
						)}
					</QueryStringContext.Consumer>
				)}
			</SettingsContext.Consumer>
		)}
	</ApiDataContext.Consumer>
);
